import { SearchableMultiSelect } from "@/components/ui/searchable-multi-select";
import type { User } from "@/types/user";
import type { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import type { FormValues } from "./form-schema";

interface UserAccessProps {
  form: UseFormReturn<FormValues>;
  users: User[];
  searchQuery: string;
  setSearchQuery: (query: string) => void;
}

export function UserAccess({
  form,
  users,
  searchQuery,
  setSearchQuery,
}: UserAccessProps) {
  const items = users.map((user) => ({
    id: user.userId,
    label: user.name,
    description: user.email,
  }));
  const { t } = useTranslation();

  return (
    <div className="max-w-[600px] mx-auto">
      <h2 className="text-2xl font-semibold mb-6">
        {t("mandanten_create.step3.title")}
      </h2>
      <SearchableMultiSelect
        form={form}
        name="selectedUsers"
        items={items}
        searchPlaceholder={t("mandanten_create.step3.search_placeholder")}
        label={t("mandanten_create.step3.user_access")}
        description={t("mandanten_create.step3.user_access_description")}
        searchValue={searchQuery}
        onSearchChange={setSearchQuery}
        defaultSelectAll
      />
    </div>
  );
}
